<div class="flex flex-col w-full justify-end gap-3 mb-3" *ngIf="data">
  <ngb-accordion #accAddress="ngbAccordion">
    <ngb-panel>
      <ng-template ngbPanelTitle>
        <div class="d-flex w-100 justify-content-between me-2">
          <label class="text-base font-medium text-black-base">
            {{ 'AdministrationService::ActualCost' | abpLocalization }}
          </label>
          <label>{{ data.actualHireCost | number : '1.2-2' }}</label>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="flex flex-col gap-3">
          <!-- <div class="flex flex-col gap-2">
            <label class="text-base font-medium text-black-base">
              {{ 'AdministrationService::HireCharge' | abpLocalization }}
            </label>
            <div class="flex flex-col gap-1 custom-table">
              <ngx-datatable
                [rows]="data ? [data] : []"
                [count]="1"
                [scrollTop]="true"
                [loadingIndicator]="isLoading"
                default
              >
                <ngx-datatable-column
                  [sortable]="false"
                  name="{{ 'RegisterService::DateHired' | abpLocalization }}"
                  prop="dateHired"
                  [width]="140"
                >
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.dateHired | date }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  [sortable]="false"
                  name="{{ 'RegisterService::Periodicity' | abpLocalization }}"
                  prop="periodicity"
                  [width]="140"
                >
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{
                      'RegisterService::' +
                        (row.periodicity === HirePeriodRange.MONTHLY ? 'Monthly' : 'Weekly')
                        | abpLocalization
                    }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="{{ 'AdministrationService::ActualAgreedRate' | abpLocalization }}"
                  prop="actualAgreedRate"
                  [sortable]="false"
                  [width]="140"
                >
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row?.actualAgreedRate }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="{{ 'RegisterService::HirePeriod' | abpLocalization }}"
                  prop="hirePeriods"
                  [sortable]="false"
                  [width]="120"
                >
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row?.hirePeriods }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  [sortable]="false"
                  name="{{ 'RegisterService::OffhireDate' | abpLocalization }}"
                  prop="offHireDate"
                  [width]="160"
                >
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row?.offHireDate | date }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [sortable]="false">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="flex items-center justify-end">
                      <button
                        type="button"
                        class="btn hover:bg-gray-20 border-gray-20 text-gray-60"
                        (click)="isModalOpen = true"
                      >
                        <i class="fas fa-pen fa-lg"></i>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div> -->
          <div class="flex flex-col gap-2">
            <label class="text-base font-medium text-black-base">
              {{ 'AdministrationService::AdditionalCharge' | abpLocalization }}
            </label>
            <app-event-table
              [data]="data.inspectionDetails"
              (viewClick)="viewClick.emit($event)"
            ></app-event-table>
          </div>
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
  <ngb-accordion #accAddress="ngbAccordion">
    <ngb-panel>
      <ng-template ngbPanelTitle>
        <div class="d-flex w-100 justify-content-between me-2">
          <label class="text-base font-medium text-black-base">
            {{ 'AdministrationService::AverageCostTitle' | abpLocalization }}
          </label>
          <label>{{ data.estimatedHireCost | number : '1.2-2' }}</label>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="flex flex-col gap-3">
          <div class="flex flex-col gap-2">
            <label for="averageHireRate" class="field-label">{{
              'AdministrationService::AverageRate' | abpLocalization
            }}</label>
            <input
              id="averageHireRate"
              [value]="data.averageHireRate"
              class="form-control"
              maxlength="64"
              readOnly
            />
          </div>
          <div class="flex flex-col gap-2">
            <label for="daysHired" class="field-label">{{
              'AdministrationService::DaysHired' | abpLocalization
            }}</label>
            <input
              id="daysHired"
              [value]="data.daysHired"
              class="form-control"
              maxlength="64"
              readOnly
            />
          </div>
          <div class="flex flex-col gap-2">
            <label for="estimatedHireCost" class="field-label">{{
              'AdministrationService::EstimatedCost' | abpLocalization
            }}</label>
            <input
              id="estimatedHireCost"
              [value]="data.estimatedHireCost"
              class="form-control"
              maxlength="64"
              readOnly
            />
            <div class="flex items-center">
              <i class="fa fa-info-circle min-w-6" aria-hidden="true"></i>
              <div class="flex flex-col gap-0.5 text-xs text-gray">
                <span>{{ 'AdministrationService::EstimatedCostTitle' | abpLocalization }}</span>
                <span>{{ 'AdministrationService::EstimatedCostInfo' | abpLocalization }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
  <!-- <app-hire-charge-picker
    *ngIf="isModalOpen"
    [data]="data"
    (requestUpdated)="refreshOpenedRequests()"
    [(isModalOpen)]="isModalOpen"
  /> -->
</div>
